import { JobPositionTypeIcon } from "@/components";
import { cn } from "@heroui/react";
import {
    type JobPosition,
    jobPositionPresets,
    JobPositionType,
    safelyRemoveSuffixFromString,
} from "@sr-partner-portal/common";

const JobPositionLabel = ({
    jobPosition,
    muted,
}: {
    jobPosition: Pick<JobPosition, "type" | "name" | "fullName"> & {
        isArchived?: boolean;
    };
    muted?: boolean;
}) => (
    <div className={cn("flex items-center gap-2", muted && "text-default-500")}>
        <JobPositionTypeIcon
            type={jobPosition.type}
            isArchived={jobPosition.isArchived}
        />
        {safelyRemoveSuffixFromString(
            jobPosition.type === JobPositionType.EMPLOYEE
                ? jobPosition.name
                : jobPosition.fullName || jobPosition.name,
            jobPositionPresets.titleSuffix,
        )}
    </div>
);

export { JobPositionLabel };
